// extracted by mini-css-extract-plugin
export default {"group":"group--a9805c"};